// Shared helper: navigate to the JUTAKU Skyline Experience slot-booking page.
// Hosted on the production site (.com); used everywhere a "Book your JUTAKU
// Experience" CTA appears on this site so the user lands on the live booking flow.
export const SKYLINE_BOOKING_URL = 'https://memcoskyline.com/book-slot';
export const EARLY_ACCESS_URL = 'https://memcoskyline.com/earlyaccess';

const trackCtaClick = (eventName, clickText) => {
  try {
    if (typeof window !== 'undefined' && window.MEMCO_VID && window.MEMCO_SID) {
      fetch('https://api.memcoskyline.com/api/analytics/track', {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event_type: 'cta_click',
          event_name: eventName,
          click_text: clickText,
          visitor_id: window.MEMCO_VID,
          session_id: window.MEMCO_SID,
          page_url: window.location.href,
        }),
      }).catch(() => {});
    }
  } catch (_) {
    /* no-op */
  }
};

export const goToSkylineBooking = () => {
  if (typeof window === 'undefined') return;
  trackCtaClick('book_jutaku_experience', 'Book your JUTAKU Experience');
  window.location.href = SKYLINE_BOOKING_URL;
};

export const goToEarlyAccess = () => {
  if (typeof window === 'undefined') return;
  trackCtaClick('get_early_access', 'Get Early Access / Register Now');
  window.location.href = EARLY_ACCESS_URL;
};
